import { z } from 'zod/v4';
import { commodityTypeEnum, matchingResolutionEnum } from './enums';

export const registryIntegrationModeEnum = z.enum(['disabled', 'semi_automatic', 'fully_automatic']);

export type RegistryIntegrationMode = z.infer<typeof registryIntegrationModeEnum>;

const supplierOrganizationConfigSchema = z.object({
  commodity_types: z.array(commodityTypeEnum).optional(),
  country_code: z.string().length(2),
  deals_enabled: z.boolean().optional(),
  default_timezone: z.string(),
  esna_enabled: z.boolean().optional(),
  esna_require_les_pdf_for_activation: z.boolean().optional(),
  hide_production_devices_from_reports: z.boolean(),
  logo_url: z.string().nullable(),
  matching_resolutions: z.array(matchingResolutionEnum).nullable(),
  name: z.string(),
  // Default boundary for demand portfolio uploads. Null when the organisation sets none.
  portfolio_locked_from: z.string().nullable().optional(),
  // Per-registry push-integration mode, keyed by registry identifier.
  registry_integration: z.record(z.string(), registryIntegrationModeEnum).optional(),
  sso_managed_users: z.boolean().optional(),
});

const endConsumerOrganizationConfigSchema = z.object({
  hide_production_devices: z.boolean(),
  name: z.string(),
  welcome_screen_enabled: z.boolean(),
});

export const userConfigSchema = z.object({
  end_consumer: endConsumerOrganizationConfigSchema.nullable(),
  feature_flags: z.object({}).catchall(z.union([z.boolean(), z.string(), z.number()])),
  supplier: supplierOrganizationConfigSchema,
});

export type UserConfigApiResponse = z.infer<typeof userConfigSchema>;
